module.exports = __webpack_public_path__ + "img/logo-blue.75660edf.svg";